<template>
  <div>
    <el-row
      type="flex"
      justify="center"
      align="center"
    >
      <el-button
        v-for="item in btnList"
        :key="item.test"
        size="small"
        @click="item.trigger(scope.row)"
      >{{item.test}}</el-button>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    tableData: Object,
    scope: Object
  },
  data() {
    return {};
  },
  mounted() {
    this.status = this.scope.row.orderStatus;
  },
  methods: {
    // 查看详情
    detail() {
      this.tableData.detail(this.scope.row);
    },
    // 查看
    check() {
      this.tableData.check(this.scope.row);
    },
    // 删除
    delOrder() {
      this.tableData.delOrder(this.scope.row);
    }
  },
  computed: {
    btnList() {
      return this.tableData.bind.filter(
        item => (item.status === this.scope.row.orderStatus || item.status === -1) && (!item.showButton || item.showButton())
      );
    }
  },
  components: {}
};
</script>

<style>
</style>
